module.exports = __webpack_public_path__ + "img/app-step-3.40bd12a8.svg";